import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import {MerchantUserSearch} from '../../../models/merchant-user';
import { AccountMasterService } from '../account-master.services';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { AllUserTypeOptions, UsersType } from '../../../utilities/common-file';
import { Messages } from 'src/app/utilities/message';
import { NzTableData } from 'src/app/utilities/nz-table.adapter';
import { AuthService } from 'src/app/auth/auth.service';
import { LocationSearch } from 'src/app/models/locations';
import { TerminalSearch } from 'src/app/models/terminals';
import { CustomValidators } from 'src/app/utilities/validator-service';

@Component({
  selector: 'app-update-profile',
  templateUrl: './update-profile.component.html',
})
export class UpdateProfileComponent implements OnInit {

    userForm: UntypedFormGroup;
    @Input() selectedUserId: any;
    selectedUser: any;
    buttonLoading = false;
    buttonLoadingForUpdate = false;
    userType: any;
    loginUserType = '';
    showFields = false;
    userTypeOptions = AllUserTypeOptions;
    errorMessage = Messages.validInput;

    private tableData: NzTableData<MerchantUserSearch, any> =
    new NzTableData<MerchantUserSearch, any>(new MerchantUserSearch(), 'fullName');
    private tableDataForLocation: NzTableData<LocationSearch, any> =
    new NzTableData<LocationSearch, any>(new LocationSearch(), 'fullName');
    private tableDataForTerminals: NzTableData<TerminalSearch, any> =
    new NzTableData<TerminalSearch, any>(new TerminalSearch(), 'fullName');
    constructor(private fb: UntypedFormBuilder, private userService: AccountMasterService, private notification: NzNotificationService,
                private drawerRef: NzDrawerRef<string>, private modalService: NzModalService, private authService: AuthService,
                private customValidators: CustomValidators) {
        this.userForm = this.fb.group({
          mobileNo: ['', [ Validators.required]],
          password: [null, [Validators.required]],
          displayName: ['', [this.customValidators.nameValidator]],
          firstName: ['', [Validators.required, this.customValidators.nameValidator]],
          lastName: ['',  [Validators.required, this.customValidators.nameValidator]],
          merchantId: [''],
          locationId: [''],
          terminalId: [''],
          type: [''],
          role: ['']
        });
      }

  ngOnInit() {
    this.loginUserType = this.authService.getRole();
    this.getUserInfo();

    // To Show Location and Terminals fields based on Login UserType

    if (this.loginUserType === UsersType.merchantUser) {
      this.showFields = false;
    } else {
      this.showFields = true;
    }
  }
  getUserInfo() {
    // tslint:disable-next-line: radix
    this.tableData.search.id =  this.authService.getUserId();
    this.tableData.search.userType = this.authService.getRole();
    this.userService.getUserInfo(this.tableData).subscribe((response: any) => {
      this.tableData.data = response.data.users;
      this.selectedUser = this.tableData.data[0];
      if (this.selectedUser) {
        this.userForm.patchValue(this.selectedUser);
        this.getLocations();
        }
    });
  }
  getLocations() {
    this.tableDataForLocation.data =  this.authService.getLocationDetails();
    this.getTerminals();
  }
  getTerminals() {
    this.tableDataForTerminals.data = Object.keys(this.authService.getTerminalDetails());
  }
  editUser() {
      const passwordControl = this.userForm.get('password');
      passwordControl.clearValidators();
      passwordControl.updateValueAndValidity();
      if (this.userForm.valid) {
          this.buttonLoadingForUpdate = true;
          const value = {
            id: this.selectedUser.id,
            displayName: this.userForm.value.displayName ? this.userForm.value.displayName : this.userForm.value.firstName,
            emailId: this.userForm.value.mobileNo,
            firstName: this.userForm.value.firstName,
            lastName: this.userForm.value.lastName,
            type: this.selectedUser.role,
            locationId: this.selectedUser.locationId ? this.selectedUser.locationId : '',
            terminalId: this.userForm.value.terminalId,
            appCode: this.selectedUser.appCode
          };
          this.userService.editUser(value).subscribe((res) => {
            this.notification.success(Messages.updated, '', {
              nzKey: 'key'
            });
            if (this.userForm.value.displayName) {
              // To set recently updated display name in profile if display name is given
              this.authService.setDisplayName(this.userForm.value.displayName);
            } else {
              // To set recently updated first name as display name in profile if display name is not given
              this.authService.setDisplayName(this.userForm.value.firstName);
            }
            if (this.selectedUser.mobileNo !== this.userForm.value.mobileNo) { // If Email ID changed by user, we route to Login Page
                this.drawerRef.close(this.selectedUser);
                this.authService.logout().subscribe((response: any) => {
                  this.showActionConfirm();
                });
            } else {
                this.close();
         }
          }, error => {
            this.buttonLoadingForUpdate = false;
          });

       } else {
        this.buttonLoadingForUpdate = false;
        // tslint:disable-next-line: forin
        for (const i in this.userForm.controls) {
          this.userForm.controls[i].markAsDirty();
          this.userForm.controls[i].updateValueAndValidity();
          this.notification.error(Messages.error, '', {
            nzKey: 'key'
          });
        }
      }
      }
      // Show Confirmation if Email ID changed
      showActionConfirm() {
        this.modalService.success({
          nzTitle: 'As You changed your email address,you need to login again',
          nzOkText: 'OK',
          nzOkType: 'danger',
        });
      }
    close() {
        this.drawerRef.close();
    }
}



